// extracted by mini-css-extract-plugin
module.exports = {"chartNote":"styles_chartNote__2wAjq"};